import { useSelector } from "react-redux";
import colors from "theme/colors";

const useColor = (color) => {
    const designColors = useSelector((state) => state.design.data);
    const colorKey = `${color}_color`;
    return designColors[colorKey] ? designColors[colorKey] : colors[color];
}

export default useColor;